import React, { memo } from 'react';
import SelectOption from './SelectOption';
import WisFilterIcon from '../svg/WisFilterIcon';
import Tag from '../AgendaContent/Tag';
import { DaysLib } from '../../Filter';

const CoursesFilterbar = ({
	availableAudiences,
	availableTags,

	memoizedActiveAudiences,
	memoizedActiveWeekdays,
	memoizedActiveTags,

	handleCourseFilter,
	getActiveLabels,
	resetParams,
	removeLabel,
	displayAmountActiveFilters,
}) => {

	return (
		<div className="courses-filter__container">
			<div className="courses-filter__select-container">
				<SelectOption
					id="audience"
					title="Voor wie"
					options={availableAudiences}
					activeOptions={memoizedActiveAudiences}
					handleCourseFilter={handleCourseFilter}
				/>
				<SelectOption
					id="weekday"
					title="Dag"
					options={DaysLib}
					activeOptions={memoizedActiveWeekdays}
					handleCourseFilter={handleCourseFilter}
				/>
				<SelectOption
					id="tag"
					title="Interesses"
					options={availableTags}
					activeOptions={memoizedActiveTags}
					handleCourseFilter={handleCourseFilter}
				/>
			</div>
			{ displayAmountActiveFilters() > 0 &&
				<div className="agenda-filter-bar__display-tags-container">
					<p className="agenda-filter-bar__Geselecteerd">{customData.i18n.agenda_filter_selected}</p>
					<button className="agenda-filter-bar__wis-filter" onClick={() => resetParams()} key={99}>
						{customData.i18n.agenda_delete_filters} <WisFilterIcon />
					</button>

					<div className="agenda-filter-bar__tags-container">
						{
							getActiveLabels().map((label, index) => {
								return (
									<Tag key={index} onclick={() => removeLabel(label.value, label.group)} index={index} tagText={label.name} displayIcon={true}/>
								);
							})
						}
					</div>
				</div>
			}

		</div>
	);
};

export default memo(CoursesFilterbar);
